// Single source of truth for NAP + business facts.
// Used by Footer, Kontakt, Impressum, and JSON-LD helpers.

export const BUSINESS = {
  name: "Ferienwohnungen Luca",
  legalName: "Familie Olaf Luca — Vermittlung von Ferienwohnungen",
  contactPerson: "Olaf Luca",
  foundingYear: "1986",
  street: "Kreuzweg 5",
  postalCode: "27476",
  city: "Cuxhaven",
  region: "Niedersachsen",
  country: "DE",
  phone: "04721-47760",
  phoneE164: "+49-4721-47760",
  email: "info@ferienwohnungen-luca.de",
  url: "https://www.ferienwohnungen-luca.de",
  priceRange: "€€",
  areaServed: ["Cuxhaven", "Duhnen", "Döse"],
} as const;

export const BUSINESS_ADDRESS_LINES = [
  `${BUSINESS.name}`,
  `${BUSINESS.street}`,
  `D-${BUSINESS.postalCode} ${BUSINESS.city}`,
];
